// crm namespace — CRM Dashboard: Performance zone.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "perf.allSales": "somme de toutes les ventes",
    "perf.colActions": "Actions",
    "perf.colClicks": "Clics",
    "perf.colEndsOn": "Se termine le",
    "perf.colItem": "Élément",
    "perf.colName": "Nom",
    "perf.colPurchases": "Achats",
    "perf.colRevenue": "Revenu",
    "perf.colType": "Type",
    "perf.colUnits": "Unités",
    "perf.colViews": "Vues",
    "perf.completed": "terminées",
    "perf.courses": "Cours vendus",
    "perf.export": "Exporter le rapport",
    "perf.from": "Du",
    "perf.newClients": "Nouveaux clients",
    "perf.offline": "Présentiel",
    "perf.online": "En ligne",
    "perf.period": "Période",
    "perf.products": "Produits vendus",
    "perf.promoStopped": "Promotion arrêtée",
    "perf.promosTitle": "Promotions en cours",
    "perf.recordsCreated": "fiches créées",
    "perf.salesTitle": "Ventes dans le temps",
    "perf.seriesCourses": "Cours",
    "perf.seriesProducts": "Produits",
    "perf.seriesSessions": "Séances",
    "perf.sessionsOffline": "Séances : en présentiel",
    "perf.sessionsOnline": "Séances : en ligne",
    "perf.splitTitle": "Répartition des séances · en ligne / présentiel",
    "perf.stopBody": "{item} quitte l'emplacement promu maintenant. Les jours restants ne sont pas remboursés.",
    "perf.stopConfirm": "Arrêter la promotion",
    "perf.stopEarly": "Arrêter plus tôt",
    "perf.stopTitle": "Arrêter cette promotion ?",
    "perf.title": "Performance",
    "perf.to": "Au",
    "perf.topEmpty": "Aucune vente sur cette période",
    "perf.topTitle": "Meilleures offres",
    "perf.totalRevenue": "Revenu total",
  },
  en: {
    "perf.allSales": "sum of all sales",
    "perf.colActions": "Actions",
    "perf.colClicks": "Clicks",
    "perf.colEndsOn": "Ends on",
    "perf.colItem": "Item",
    "perf.colName": "Name",
    "perf.colPurchases": "Purch.",
    "perf.colRevenue": "Revenue",
    "perf.colType": "Type",
    "perf.colUnits": "Units",
    "perf.colViews": "Views",
    "perf.completed": "completed",
    "perf.courses": "Courses sold",
    "perf.export": "Export report",
    "perf.from": "From",
    "perf.newClients": "New clients",
    "perf.offline": "Offline",
    "perf.online": "Online",
    "perf.period": "Period",
    "perf.products": "Products sold",
    "perf.promoStopped": "Promotion stopped",
    "perf.promosTitle": "Active promotions",
    "perf.recordsCreated": "records created",
    "perf.salesTitle": "Sales over time",
    "perf.seriesCourses": "Courses",
    "perf.seriesProducts": "Products",
    "perf.seriesSessions": "Sessions",
    "perf.sessionsOffline": "Sessions: offline",
    "perf.sessionsOnline": "Sessions: online",
    "perf.splitTitle": "Sessions split · online vs offline",
    "perf.stopBody": "{item} leaves the promoted placement now. The remaining days are not refunded.",
    "perf.stopConfirm": "Stop promotion",
    "perf.stopEarly": "Stop early",
    "perf.stopTitle": "Stop this promotion?",
    "perf.title": "Performance",
    "perf.to": "To",
    "perf.topEmpty": "No sales in this period",
    "perf.topTitle": "Top offerings",
    "perf.totalRevenue": "Total revenue",
  },
  es: {
    "perf.allSales": "suma de todas las ventas",
    "perf.colActions": "Acciones",
    "perf.colClicks": "Clics",
    "perf.colEndsOn": "Termina el",
    "perf.colItem": "Elemento",
    "perf.colName": "Nombre",
    "perf.colPurchases": "Compras",
    "perf.colRevenue": "Ingresos",
    "perf.colType": "Tipo",
    "perf.colUnits": "Unidades",
    "perf.colViews": "Vistas",
    "perf.completed": "completadas",
    "perf.courses": "Cursos vendidos",
    "perf.export": "Exportar informe",
    "perf.from": "Desde",
    "perf.newClients": "Clientes nuevos",
    "perf.offline": "Presencial",
    "perf.online": "En línea",
    "perf.period": "Periodo",
    "perf.products": "Productos vendidos",
    "perf.promoStopped": "Promoción detenida",
    "perf.promosTitle": "Promociones activas",
    "perf.recordsCreated": "fichas creadas",
    "perf.salesTitle": "Ventas en el tiempo",
    "perf.seriesCourses": "Cursos",
    "perf.seriesProducts": "Productos",
    "perf.seriesSessions": "Sesiones",
    "perf.sessionsOffline": "Sesiones: presenciales",
    "perf.sessionsOnline": "Sesiones: en línea",
    "perf.splitTitle": "Reparto de sesiones · en línea / presencial",
    "perf.stopBody": "{item} sale ahora del espacio promocionado. Los días restantes no se reembolsan.",
    "perf.stopConfirm": "Detener la promoción",
    "perf.stopEarly": "Detener antes",
    "perf.stopTitle": "¿Detener esta promoción?",
    "perf.title": "Rendimiento",
    "perf.to": "Hasta",
    "perf.topEmpty": "Sin ventas en este periodo",
    "perf.topTitle": "Ofertas principales",
    "perf.totalRevenue": "Ingresos totales",
  },
};
